"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.title,
      "confirm-loading": _vm.loading || _vm.uploading
    },
    on: {
      ok: _vm.submit,
      cancel: _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "content"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "发表评论"
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "fileList"
    }
  }, [_c("ys-upload", {
    attrs: {
      accept: ".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx",
      "max-count": 3,
      uploading: _vm.uploading
    },
    on: {
      "update:uploading": function ($event) {
        _vm.uploading = $event;
      }
    },
    model: {
      value: _vm.form.fileList,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fileList", $$v);
      },
      expression: "form.fileList"
    }
  }), _c("span", {
    staticStyle: {
      color: "#8c8c8c"
    }
  }, [_vm._v(" 支持扩展名：.jpg .jpeg .png .pdf .doc .docx .xls .xlsx ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;